import slide1EnPng from '/img/presentation/slide-1-en.png';
import slide1RuPng from '/img/presentation/slide-1-ru.png';
import slide2EnPng from '/img/presentation/slide-2-en.png';
import slide2RuPng from '/img/presentation/slide-2-ru.png';
import slide3EnPng from '/img/presentation/slide-3-en.png';
import slide3RuPng from '/img/presentation/slide-3-ru.png';
import slide4EnPng from '/img/presentation/slide-4-en.png';
import slide4RuPng from '/img/presentation/slide-4-ru.png';
import slide5EnPng from '/img/presentation/slide-5-en.png';
import slide5RuPng from '/img/presentation/slide-5-ru.png';
import slide6EnPng from '/img/presentation/slide-6-en.png';
import slide6RuPng from '/img/presentation/slide-6-ru.png';
import slide7EnPng from '/img/presentation/slide-7-en.png';
import slide7RuPng from '/img/presentation/slide-7-ru.png';

const slides = {
  en: [
    {
      image: {
        png: slide1EnPng,
        alt: 'slide-1',
      },
      btnText: 'Sure!',
    },
    {
      image: {
        png: slide2EnPng,
        alt: 'slide-2',
      },
      btnText: 'What are the contracts?',
    },
    {
      image: {
        png: slide3EnPng,
        alt: 'slide-3',
      },
      btnText: 'What are Star Points?',
    },
    {
      image: {
        png: slide4EnPng,
        alt: 'slide-4',
      },
      btnText: "Let's take a closer look",
    },
    {
      image: {
        png: slide5EnPng,
        alt: 'slide-5',
      },
      btnText: "Got it, what's next?",
    },
    {
      image: {
        png: slide6EnPng,
        alt: 'slide-6',
      },
      btnText: "Got it, what's next?",
    },
    {
      image: {
        png: slide7EnPng,
        alt: 'slide-7',
      },
      btnText: 'Now everything is clear!',
    },
  ],
  ru: [
    {
      image: {
        png: slide1RuPng,
        alt: 'slide-1',
      },
      btnText: 'Sure!',
    },
    {
      image: {
        png: slide2RuPng,
        alt: 'slide-2',
      },
      btnText: 'What are the contracts?',
    },
    {
      image: {
        png: slide3RuPng,
        alt: 'slide-3',
      },
      btnText: 'What are Star Points?',
    },
    {
      image: {
        png: slide4RuPng,
        alt: 'slide-4',
      },
      btnText: "Let's take a closer look",
    },
    {
      image: {
        png: slide5RuPng,
        alt: 'slide-5',
      },
      btnText: "Got it, what's next?",
    },
    {
      image: {
        png: slide6RuPng,
        alt: 'slide-6',
      },
      btnText: "Got it, what's next?",
    },
    {
      image: {
        png: slide7RuPng,
        alt: 'slide-7',
      },
      btnText: 'Now everything is clear!',
    },
  ],
};

export { slides };
